import DraftsIcon from "@mui/icons-material/Drafts";
import ListReportDisPostOffice from "./List";

//params
export const REPORT_DISCOUNT_POST_OFFICE = "districts/first-reference";

//permissions

export const resources = {
  isMenu: true,
  icon: <DraftsIcon />,
  name: REPORT_DISCOUNT_POST_OFFICE,
  title: "Справка - ОПС 1",
  list: <ListReportDisPostOffice />,
  permission: "editions",
};

//api url
